// Acorn Finance financing pre-qualification banner (soft pull, no impact to credit).
export const FinancingBanner = ({ className = "", compact = false }) => (
  <div className={`text-center ${className}`} data-testid="financing-banner">
    {!compact && (
      <p className="text-sm font-semibold text-navy mb-1">Flexible monthly payment options</p>
    )}
    {!compact && (
      <p className="text-xs text-slate-500 mb-2">Check your rate in minutes — pre-qualifying won’t affect your credit score.</p>
    )}
    <a href="https://www.acornfinance.com/pre-qualify/?d=60L47&utm_medium=web_pre_qual_banner"
       target="_blank" rel="noopener noreferrer" data-testid="financing-link"
       className="inline-block transition-transform hover:scale-[1.02]">
      <img id="acornBanner"
           style={{ margin: "10px", padding: "1px", border: "1px solid black", borderRadius: "5px", maxWidth: "100%", height: "auto" }}
           src="https://fs.acornfinance.com/banners/acorn-finance-banner-easy-payment-options-horizontal-small.png"
           alt="Acorn Finance — apply and get affordable payment options from multiple lenders" />
    </a>
  </div>
);

export default FinancingBanner;
